import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
const Layout = styled.div`
  * {
    box-sizing: 0;
    margin: 0;
    padding: 0;
    cursor: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/4424790/cursors-edge.png"),
      auto;
  }

  body {
    background: linear-gradient(to right, white 50%, $seed 50%);
    font-family: "Roboto", sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5;
    color: white;
  }

  div {
    display: flex;
    align-items: center;
    height: 100vh;
    max-width: 1000px;
    width: calc(100% - #{$lg});
    margin: 0 auto;
    > * {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      max-width: 500px;
      width: 100%;
      padding: $md;
    }
  }

  aside {
    background-image: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/4424790/right-edges.png");
    background-position: top right;
    background-repeat: no-repeat;
    background-size: 25px 100%;
    img {
      display: block;
      height: auto;
      width: 100%;
    }
  }

  main {
    text-align: center;
    h1 {
      font-family: "Fontdiner Swanky", cursive;
      font-size: $lg;
      color: $lime;
      margin-bottom: $sm;
    }
    p {
      margin-bottom: $md;
      em {
        font-style: italic;
        color: $lime;
      }
    }
  }

  @media (max-width: 700px) {
    body {
      background: $seed;
      font-size: 16px;
    }
    div {
      flex-flow: column;
      > * {
        max-width: 700px;
        height: 100%;
      }
    }
    aside {
      background-image: none;
      background-color: white;
      img {
        max-width: 300px;
      }
    }
  }
`;
export default function NotFound() {
  return (
    <>
      <Layout>
        <div>
          <aside>
            <img
              src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/4424790/Mirror.png"
              alt="404 pix"
            />
          </aside>
          <main>
            <h1>Sorry!</h1>
            <p>
              the page you are looking for does not exist{" "}
              <Link to="/">
                <em>. . .please go home.</em>
              </Link>
            </p>
          </main>
        </div>
      </Layout>
    </>
  );
}
